/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
import { ISummaryResult_$type } from "./ISummaryResult";
/**
 * @hidden
 */
var DefaultSummaryResult = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefaultSummaryResult, _super);
    function DefaultSummaryResult(a, b, c) {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.c = null;
        _this.a = 0;
        _this.b = 0;
        _this.d = a;
        _this.a = b;
        _this.c = c;
        return _this;
    }
    Object.defineProperty(DefaultSummaryResult.prototype, "propertyName", {
        get: function () {
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultSummaryResult.prototype, "operand", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultSummaryResult.prototype, "value", {
        get: function () {
            return this.c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultSummaryResult.prototype, "summaryIndex", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            this.b = a;
        },
        enumerable: true,
        configurable: true
    });
    DefaultSummaryResult.$t = markType(DefaultSummaryResult, 'DefaultSummaryResult', Base.$, [ISummaryResult_$type]);
    return DefaultSummaryResult;
}(Base));
export { DefaultSummaryResult };
//# sourceMappingURL=DefaultSummaryResult.js.map
